<template>
  <div class="container">
    <nullPageModule></nullPageModule>
  </div>
</template>

<script>
import nullPageModule from "../../components/nullPageModule.vue";
export default {
  components: {
    nullPageModule,
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
